import { SystemEntity } from '@backstage/catalog-model';
import { Card, CardContent, CardHeader, createStyles, Divider, List, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { GoogleProviderLinks } from './google/GoogleProviderLinks';

const useStyles = makeStyles(createStyles({
    divider: { marginTop: '1em' }
}));

export const EntityCloudProviderCard = (props: { system: SystemEntity | undefined }) => {

    const { system } = props;
    const classes = useStyles();

    return (<Card>
        <CardHeader title="Cloud Provider" />
        <Divider className={classes.divider} />
        <CardContent>
            {system ? (
                <List dense>
                    <GoogleProviderLinks system={system} />
                </List>
            ) : (
                <Typography>No system was identified.</Typography>
            )}
        </CardContent>
    </Card>);
}